import RightOutlinedIcon from '@ant-design/icons/RightOutlined'

export default function AccordionSummary(theme) {
  return {
    MuiAccordionSummary: {
      defaultProps: {
        expandIcon: <RightOutlinedIcon style={{ fontSize: '0.75rem' }} />,
      },
      styleOverrides: {
        root: {
          flexDirection: 'row-reverse',
        },
        expandIconWrapper: {
          '&.Mui-expanded': {
            transform: 'rotate(90deg)',
          },
        },
        content: {
          marginLeft: `${theme.spacing(2)} !important`,
        },
      },
    },
  }
}
